import type {
  CyanTakeoverChatController,
  CyanTakeoverChatContext,
} from "./cyanTakeoverChatController";

import type { CyanOperationalSessionStore } from "./cyanOperationalSessionStore";

import type { CyanTakeoverLiveViewModel } from "./operationalTakeoverViewModel";

export interface CyanLiveTakeoverBridgeResult {
  readonly handled: boolean;

  readonly summary: string;

  readonly view: CyanTakeoverLiveViewModel | null;
}

/**
 * Keeps operational-program state associated with the current
 * Cyan conversation while normal chat remains free to continue.
 */
export class CyanLiveTakeoverBridge {
  constructor(
    private readonly controller: CyanTakeoverChatController,

    private readonly sessions: CyanOperationalSessionStore,
  ) {}

  async handle(
    conversationId: string,

    message: string,

    context: CyanTakeoverChatContext,
  ): Promise<CyanLiveTakeoverBridgeResult> {
    const current = await this.sessions.get(conversationId);

    const result = await this.controller.handle(message, current, context);

    if (result.session) {
      await this.sessions.save(conversationId, result.session);
    }

    return {
      handled: result.handled,

      summary: result.summary,

      view: result.session?.view ?? null,
    };
  }

  async refresh(
    conversationId: string,

    context: CyanTakeoverChatContext,
  ): Promise<CyanLiveTakeoverBridgeResult> {
    return this.handle(conversationId, "update status", context);
  }
}
